import React from 'react'
import styled from 'styled-components'

const Foot = styled.footer`
  position: fixed;
  bottom: -1px;
  width: 100%;
  text-align: center;
  z-index: 1;
`
const Bottom = styled.div`
background: rgba(17, 17, 17);
padding: 10px 0; 
`
const Text = styled.h6`
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  color: #e8eddf;
`

export default function Footer() {
  return (
    <>
      <Foot>
        <Bottom>
          <Text>&copy; Stefon Simmons</Text>
        </Bottom>
      </Foot>
    </>
  )
}
